/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tree-folder-icon[_ngcontent-%COMP%]{margin:2px}.mat-tree-node[_ngcontent-%COMP%]{margin:0 auto;white-space:nowrap}.mat-tree-node[_ngcontent-%COMP%]:hover{background:var(--alternative-color);cursor:pointer}.selected-folder[_ngcontent-%COMP%]{background:var(--primary-color)!important;color:var(--text-primary-color)!important}.tree-folder-name[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
